import { module } from 'modujs';
import { gsap } from 'gsap';

const CLASS_OPEN = 'is-open'

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            click: {
                close: 'close',
                background: 'close'
            }
        }
    }

    init() {
        this.id = this.el.getAttribute('data-id');
        let hash = window.location.hash;

        // console.log(id, hash);

        if(hash != undefined) {
            if(hash.substring(1,hash.length) == this.id) {
                gsap.delayedCall(window.readyCallbackDelay + 2, () => {
                    this.open();
                })
            }
        }
        
    }

    open() {
        this.el.classList.add(CLASS_OPEN);
        history.pushState(null, null, `#${this.id}`);

    }

    close() {
        this.el.classList.remove(CLASS_OPEN);
        history.pushState(null, null, '#');

    }
}
